<div class="top">
  <h2 mat-dialog-title>
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#location-s"></use></svg>
    Vælg lokationer
  </h2>
  <a (click)="loadSelectedLocations()" class="top__chosen btn-icon">
    <div matBadge="{{ selectedLocations.length }}" matBadgeOverlap="false">Valgt</div>
  </a>
  <a (click)="resetLocations()" class="top__reset btn-icon">Nulstil valg</a>
  <button class="btn-close btn-icon" mat-dialog-close>
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="actions" [formGroup]="filterModel">
    <mat-form-field class="actions__query">
      <mat-label>Søg lokationer</mat-label>
      <input matInput placeholder="Navn eller adresse" formControlName="query" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-form-field class="actions__departments">
      <mat-label>Vælg afdeling</mat-label>
      <mat-select #departmentSelect formControlName="selectedDepartmentId" okCustomDropDownArrowDirective>
        <mat-option [value]="null">Alle</mat-option>
        @for (department of departments; track department) {
          <mat-option [value]="department.id">
            {{ department.name }}
          </mat-option>
        }
      </mat-select>
      <mat-icon matSuffix></mat-icon>
    </mat-form-field>
  </div>

  <div>
    <div mat-dialog-content class="locations-selector">
      <adm-loading-spinner [loading$]="loading"></adm-loading-spinner>
      <mat-selection-list #locations [formControl]="locationCheckboxes">
        @for (location of locationItems; track location) {
          <mat-list-option
            class="locations-selector__locations-item"
            checkboxPosition="after"
            [value]="location"
            [selected]="location.checked"
            (click)="locationOptionWasClicked(location.identifier)">
            <div class="locations-selector__locations-item--name">
              {{ location.name }}
            </div>
            <div class="locations-selector__locations-item--address">
              {{ location.address | formatAddress }}
            </div>
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="actions__button" type="submit" mat-flat-button color="primary" (click)="saveAndClose()">Anvend</button>
</mat-dialog-actions>
